import axiosInstance from "../tokenInterceptor/AxiosInstance";

export default class SponsorService {
  constructor() {
    this.baseUrl = "/sponsor";
  }

  // ------------------------
  // SEARCH COMPANIES
  // ------------------------
  async searchCompanies(companyName, token) {
    return axiosInstance.get(
      `${this.baseUrl}/search-companies?companyName=${encodeURIComponent(
        companyName
      )}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  }

  // ------------------------
  // FETCH CARD PASSES
  // ------------------------
  async fetchCardPasses(companyName, token) {
    return axiosInstance.get(
      `${this.baseUrl}/card-passes?companyName=${encodeURIComponent(
        companyName
      )}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  }

  // ------------------------
  // REGISTER SPONSOR
  // ------------------------
  async registerSponsor(data, token) {
    return axiosInstance.post(`${this.baseUrl}/register`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  // ------------------------
  // SAVE ATTENDEES
  // ------------------------
  async saveAttendees(sponsorId, attendees, token) {
    return axiosInstance.post(
      `${this.baseUrl}/${sponsorId}/attendees`,
      attendees,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  }
}
